import { orderFilterLabelsText } from '@epicuro-next/constants/features/localization';
import { FiltersFieldIds } from '@epicuro-next/models/order-book';

export const filterLabels: { [key in FiltersFieldIds]: string } = {
  [FiltersFieldIds.PlacedPeriod]: orderFilterLabelsText.placedPeriodText,
  [FiltersFieldIds.OrderType]: orderFilterLabelsText.orderTypeText,
  [FiltersFieldIds.Address]: orderFilterLabelsText.addressText,
  [FiltersFieldIds.DeliveryMonth]: orderFilterLabelsText.deliveryMonthText,
  [FiltersFieldIds.DeliveryYear]: orderFilterLabelsText.deliveryYearText,
  [FiltersFieldIds.OrderStatus]: orderFilterLabelsText.orderStatusText,
  [FiltersFieldIds.OrderIncoming]: orderFilterLabelsText.orderStatusText,
  [FiltersFieldIds.Brand]: orderFilterLabelsText.brandText,
  [FiltersFieldIds.SubBrand]: orderFilterLabelsText.subBrandText,
  [FiltersFieldIds.Category]: orderFilterLabelsText.categoryText,
  [FiltersFieldIds.Noos]: orderFilterLabelsText.noosText,
  [FiltersFieldIds.AccountId]: orderFilterLabelsText.accountIdText,
  [FiltersFieldIds.Division]: orderFilterLabelsText.divisionText,
  [FiltersFieldIds.MaterialGroup]: orderFilterLabelsText.materialGroupText,
};
